import { Alert } from "@mui/material";
import {
	BooleanField,
	DateField,
	DeleteButton,
	EditButton,
	EmailField,
	Show,
	SimpleShowLayout,
	TextField,
	TopToolbar,
	useRecordContext,
} from "react-admin";
import { RestoreButton } from "@/components/RestoreButton";

const PartnerShowActions = () => {
	const record = useRecordContext();

	return (
		<TopToolbar>
			<EditButton />
			{record?.deletedAt ? (
				<RestoreButton resource="partners" />
			) : (
				<DeleteButton />
			)}
		</TopToolbar>
	);
};

const DeletedAlert = () => {
	const record = useRecordContext();
	if (!record?.deletedAt) return null;

	return (
		<Alert severity="warning" sx={{ mb: 2 }}>
			This partner was deleted on{" "}
			{new Date(record.deletedAt).toLocaleDateString()}.
		</Alert>
	);
};

export const PartnerShow = () => (
	<Show actions={<PartnerShowActions />}>
		<DeletedAlert />
		<SimpleShowLayout>
			<TextField source="id" />
			<TextField source="name" />
			<TextField source="ownerId" label="Owner ID" />
			<EmailField source="ownerEmail" label="Owner Email" />
			<BooleanField source="payoutEnabled" label="Payout Enabled" />
			<TextField
				source="stripeAccountId"
				label="Stripe Account"
				emptyText="-"
			/>
			<DateField source="createdAt" label="Created" showTime />
			<DateField source="archivedAt" label="Archived" showTime emptyText="-" />
			<DateField source="deletedAt" label="Deleted" showTime emptyText="-" />
		</SimpleShowLayout>
	</Show>
);
